import { Button, Grid, darken, Skeleton } from "@mui/material";
import { useIntl } from "react-intl";

export default function CommonBackButtonExternal({ clientportal, loading, handleBack, gridProps }) {
  const intl = useIntl();

  if (loading) {
    return (
      <Grid item sm={12} {...gridProps}>
        <Skeleton variant="rounded" width={72} height={36} sx={{ borderRadius: 1 }} />
      </Grid>
    )
  }

  return (
    <Grid item sm={12} {...gridProps}>
      {clientportal &&
        (clientportal.defaultcolor && clientportal.defaultcolor.length > 0) ?
        <Button
          variant="contained"
          color="primary"
          onClick={handleBack}
          sx={{
            backgroundColor: `${clientportal.defaultcolor} !important`,
            color: '#fff',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: `${darken(clientportal.defaultcolor, 0.2)} !important`,
            },
          }}
        >
          {intl.formatMessage({ id: "back" })}
        </Button>
        :
        clientportal &&
        <Button
          variant="contained"
          color="success"
          onClick={handleBack}
          sx={{ textTransform: 'none' }}
        >
          {intl.formatMessage({ id: "back" })}
        </Button>
      }
    </Grid>
  )
}